module.exports = __webpack_public_path__ + "img/LI107370.a7bc0060.svg";